import { FC } from "react";

interface Props {}

export const PageContainer: FC<Props> = (props) => {
  return <div>{props.children}</div>;
};
